import React from "react";

import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface UploadInfoProps {
  mode: string;
}

const UploadInfo: React.FC<UploadInfoProps> = ({ mode }) => {
  const theme = useTheme();

  if (mode === "geo") {
    return (
      <Stack spacing={1} sx={{ mb: 2 }}>
        <Typography>
          Upload a CSV file containing a postcode or sector column. Your file
          can also (optionally) include a segment column.
        </Typography>
        <Typography gutterBottom>
          An example file format is as follows
        </Typography>
        <Box sx={{ pt: 2 }}>
          <TableContainer component={Paper} sx={{ width: 240 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{}}>
                  <TableCell
                    sx={{
                      fontFamily: "cera-pro-bold",
                      borderBottomColor: theme.palette.divider,
                    }}
                  >
                    Postcode
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "cera-pro-bold",
                      borderBottomColor: theme.palette.divider,
                    }}
                  >
                    Segment
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                    ABC 123
                  </TableCell>
                  <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                    Segment 1
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ABC 456</TableCell>
                  <TableCell>Segment 2</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Stack>
    );
  } else {
    return null;
  }
};

export default UploadInfo;
